import { Media, MediaFormat } from 'types/order-join-flow';

type MediaRelationInput = { data?: Media | null } | null | undefined;

const DEFAULT_MEDIA_DATE = new Date();

export const ensureMediaRelation = (
  relation: MediaRelationInput,
): { data: Media } => {
  if (relation?.data?.attributes) {
    return {
      data: {
        ...relation.data,
        attributes: relation.data.attributes,
      },
    };
  }

  return {
    data: createDefaultMedia(relation?.data?.id ?? 0),
  };
};

export const createDefaultMedia = (id = 0): Media => {
  return {
    id,
    attributes: createDefaultMediaAttributes(),
  };
};

export const createDefaultMediaAttributes = (): Media['attributes'] => {
  return {
    name: '',
    alternativeText: '',
    caption: '',
    width: 0,
    height: 0,
    formats: {
      small: createDefaultMediaFormat(),
      medium: createDefaultMediaFormat(),
      large: createDefaultMediaFormat(),
      thumbnail: createDefaultMediaFormat(),
    },
    hash: '',
    ext: '',
    mime: '',
    size: 0,
    url: '',
    previewUrl: '',
    provider: '',
    provider_metadata: {
      public_id: '',
      resource_type: '',
    },
    createdAt: DEFAULT_MEDIA_DATE,
    updatedAt: DEFAULT_MEDIA_DATE,
  };
};

export const createDefaultMediaFormat = (): MediaFormat => {
  return {
    ext: '',
    url: '',
    hash: '',
    mime: '',
    name: '',
    path: '',
    size: 0,
    width: 0,
    height: 0,
  };
};
